import $ from 'jquery';

// test visibility of an element
$.fn.isVisible = function () {
    return this.length == 0 ? false : $(this.first()).css('display') !== 'none';
};